import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import rootReducer from "./store/Saga";
import { allAppRootSagas } from "./store/Saga/rootSagas";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Auth0Provider } from "@auth0/auth0-react";
import { HelmetProvider } from "react-helmet-async";
import { applyGoogleTranslateDomPatch } from "./utils/googleTranslateDomPatch";
import AuthTokenBridge from "./components/auth/AuthTokenBridge";
import { getAuthScope } from "./utils/authTokenService";

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

applyGoogleTranslateDomPatch();

const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(allAppRootSagas);

createRoot(document.getElementById("root")).render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    cacheLocation="localstorage"
    useRefreshTokens={true}
    useRefreshTokensFallback={true}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: process.env.REACT_APP_AUDIENCE_URL,
      scope: getAuthScope(),
    }}
  >
    <Provider store={store}>
      <GoogleOAuthProvider clientId="490413240407-jrqrupdrda8gimvrbt3o3bvs4qtcjgv2.apps.googleusercontent.com">
        <HelmetProvider>
          <AuthTokenBridge />
          <App />
        </HelmetProvider>
      </GoogleOAuthProvider>
    </Provider>
  </Auth0Provider>
);
reportWebVitals();
